import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseTransfersResponse as SchemaDeliveryWarehouseTransfersResponse } from '../schemas/DeliveryWarehouseTransfersResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryWarehouseTransfersContentType = '' as const;
export type GetDeliveryWarehouseTransfersRequest = void;
export type GetDeliveryWarehouseTransfersResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse transfers
     */
    '200': {
        'application/json': SchemaDeliveryWarehouseTransfersResponse;
    };
};
export type GetDeliveryWarehouseTransfersResponseSuccess =
    GetDeliveryWarehouseTransfersResponses['200']['application/json'];
export type GetDeliveryWarehouseTransfersSearchParams = undefined;
export type GetDeliveryWarehouseTransfersPathParameters = {
    warehouse_id: string;
};
export const GetDeliveryWarehouseTransfersUrl = '/delivery/warehouse/{warehouse_id}/transfers' as const;
export const GetDeliveryWarehouseTransfersMethod = 'GET' as const;
export const getGetDeliveryWarehouseTransfersUrl = (params: GetDeliveryWarehouseTransfersPathParameters) =>
    GetDeliveryWarehouseTransfersUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetDeliveryWarehouseTransfersPathParameters) => String(params[param])
    );
